// extracted by mini-css-extract-plugin
export default {"wrapper":"RadioGroup_wrapper__mbLUX","radioElement":"RadioGroup_radioElement__7TSCa","label":"RadioGroup_label__gRjox"};